import cx from "classnames";
import { ArrowDropUp } from "@bloomberg/media-ui-iconography";

import { LittlePillProps } from "./types";

import styles from "./styles.module.css";

const getClassNameBasedOnChangeDirection = (percentChange) =>
  percentChange > 0
    ? styles.up
    : percentChange < 0
      ? styles.down
      : styles.neutral;

export const PercentChange = ({ percentChange }) => {
  const prefix = percentChange > 0 ? "+" : "";

  return (
    <div className={styles.percentChange}>
      <div className={styles.triangle}>
        <ArrowDropUp aria-label="Arrow" />
      </div>
      {prefix}
      {Number(percentChange)?.toFixed(2)}%
    </div>
  );
};

PercentChange.displayName = "LittlePill.PercentChange";

export function Component(props: LittlePillProps) {
  const { label, value, percentChange } = props;

  return (
    <div
      className={cx(
        styles.littlePillContainer,
        getClassNameBasedOnChangeDirection(percentChange)
      )}
    >
      <div className={styles.contents}>
        <div className={styles.labelAndValue}>
          <label className={styles.label}>{label}</label>
          <div className={styles.value}>{value?.toFixed(2)}</div>
        </div>
        <div className={styles.percentChangeContainer}>
          <PercentChange percentChange={percentChange} />
        </div>
      </div>
    </div>
  );
}
Component.displayName = "LittlePill.Component";
